import * as React from 'react';
import * as Forms from '../../../../components/form-elements/_index';
import { DealerRead } from '../../../../support/models/dealers/dealer-read';
import { SelectListItem } from '../../../../models/utilities/selectlist-item';
import { CreditHoldReasonMetadata } from '../../../../support/models/enums/credit-hold-reason';
import { ShippingMethodSelectList } from '../../../../models/enums/shipping-method';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';

interface IProps {
    dealer: DealerRead;
    onDealerChange: any;
    addresses: ShipToAddressRead[];
}

export const DealerEditBasicInfo = (props: IProps) => {
    const [editDealer, setEditDealer] = React.useState<DealerRead>(new DealerRead());

    const [shipToAddresses] = React.useState(() => {
        const addresses: Array<SelectListItem<string>> = [];
        addresses.push(new SelectListItem({
            id: '', name: '<none>'
        }));
        for (let i = 0; i < props.addresses.length; i++) {
            const address = props.addresses[i];
            addresses.push(new SelectListItem({
                id: address.id, name: address.name
            }));
        }
        return addresses
    });

    const [creditHoldReasons] = React.useState(() => {
        const reasons: Array<SelectListItem<string>> = [];
        reasons.push(new SelectListItem({
            id: '', name: '<none>'
        }));
        for (let i in CreditHoldReasonMetadata) {

            let reason = CreditHoldReasonMetadata[i as keyof typeof CreditHoldReasonMetadata];

            reasons.push(new SelectListItem({
                id: reason.value, name: reason.display
            }));
        }
        return reasons
    });

    const [shippingMethods] = React.useState(() => {
        const methods: Array<SelectListItem<string>> = [];
        methods.push(new SelectListItem({
            id: '', name: '<none>'
        }));
        for (let i in CreditHoldReasonMetadata) {

            let reason = CreditHoldReasonMetadata[i as keyof typeof CreditHoldReasonMetadata];

            methods.push(new SelectListItem({
                id: reason.value, name: reason.display
            }));
        }
        return methods
    });

    React.useEffect(() => {
        if (props.dealer) {
            setEditDealer({ ...props.dealer });
        }
    }, [props.dealer]);

    const onCreditHoldReasonChange = (e: any) => {
        const t = { ...editDealer } as DealerRead;
        if (e.target.value == -1) {
            t.creditHoldReason = undefined;
        }
        else {
            t.creditHoldReason = parseInt(e.target.value, 10);
        }
        setEditDealer(t);
        props.onDealerChange(t);
    };

    const onDefaultShippingMethodChange = (e: any) => {
        const t = { ...editDealer } as DealerRead;
        if (e.target.value == -1) {
            t.defaultShippingMethod = undefined;
        }
        else {
            t.defaultShippingMethod = parseInt(e.target.value, 10);
        }
        setEditDealer(t);
        props.onDealerChange(t);
    }

    const onDefaultShipToAddressChange = (e: any) => {
        const t = { ...editDealer } as DealerRead;
        if (e.target.value == -1) {
            t.defaultShipToAddressId = undefined;
        }
        else {
            t.defaultShipToAddressId = e.target.value;
        }
        setEditDealer(t);
        props.onDealerChange(t);
    }

    const shouldDisableCreditHoldReason = () => {
        return !editDealer.isOnCreditHold;
    };

    return editDealer
        ? <React.Fragment>

            <div className="row">
                <div className={"col-md-12"}>
                    <Forms.SelectInput
                        id="creditHoldReason"
                        testID="dealer-basic-info-credit-hold-reason"
                        label="Credit Hold Reason"
                        onChange={onCreditHoldReasonChange}
                        options={creditHoldReasons}
                        value={editDealer.creditHoldReason}
                        default={-1}
                        disable={shouldDisableCreditHoldReason()} />
                </div>
            </div>
            <div className="row">
                <div className={"col-md-12"}>
                    <Forms.SelectInput
                        id="defaultShippingMethod"
                        testID="dealer-default-shipping-method"
                        label="Default Shipping Method"
                        onChange={onDefaultShippingMethodChange}
                        options={ShippingMethodSelectList}
                        value={editDealer.defaultShippingMethod}
                        default={-1} />
                </div>
            </div>
            <div className="row">
                <div className={"col-md-12"}>
                    <Forms.SelectInput
                        id="defaultShipToAddress"
                        testID="dealer-default-ship-to-address"
                        label="Default Delivery Address"
                        onChange={onDefaultShipToAddressChange}
                        options={shipToAddresses}
                        value={editDealer.defaultShipToAddressId}
                        default={-1} />
                </div>
            </div>

        </React.Fragment>
        : null;
};
